import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '../@config/endpoints';
import { NotificationEntry, NotificationList } from '../@models';
import { Pagination } from '../@config';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http: HttpClient) { }

  getNotifications(startDate: string, endDate: string, skipCount: number): Observable<NotificationList> {
    return this.http.get<NotificationList>(ENDPOINTS.getNotifications(startDate, endDate, Pagination.maxResultCount, skipCount)).pipe(
      map((respone: any) => respone?.result || []));
  }

  markAsRead(id : String):  Observable<any>{
    return this.http.post<any>(ENDPOINTS.setNotificationAsRead(),{"id":id}).pipe(
      map((respone: any) => respone?.success || []));
  }

  markAllAsRead():  Observable<any>{
    return this.http.post<any>(ENDPOINTS.setAllNotificationsAsRead(),{}).pipe(
      map((respone: any) => respone?.success || []));
  }

}
